import styled from "styled-components";

export const GalleryWrapper = styled.div`
  margin-top: 80px;
  color: #fff;
  background: url("assets/back.png") no-repeat;
  width: 100%;
  background-size: 100% 100%;
`;

export const GalleryContainer = styled.div`
  max-width: 1200px;
  width: 95%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const GalleryHeader = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 64px;
`;

export const GalleryDesc = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 64px;
`;

export const GalleryButtons = styled.div`
  width: 95%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  gap: 13px;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 1024px) {
    flex-wrap: wrap;
  }
`;

export const GalleryButton = styled.div`
  cursor: pointer;
  width: 290px;
  height: 60px;
  flex: none;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #e11d48;
  border-radius: 6px;
  filter: drop-shadow(1px 1px 0px #772436);
  color: #e11d48;
  background-color: transparent;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 170%;
  transition: all 0.3s;
  user-select: none;
  &:hover {
    color: #fff;
    background: #e11d48;
  }
  &.activebtn {
    color: #fff;
    background: #e11d48;
  }
  @media screen and (max-width: 1260px) {
    width: 240px;
    height: 40px;
  }
  @media screen and (max-width: 1024px) {
    width: 220px;
    height: 36px;
  }
`;

// export const GalleryItem = styled.div`
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   justify-content: center;
//   gap: 12px;
//   img {
//     width: 100%;
//     height: auto;
//   }
// `;

// export const GalleryItems = styled.div`
//   width: 100%;
//   display: flex;
//   flex-direction: row;
//   align-items: flex-start;
//   justify-content: center;
//   gap: 12px;
//   padding-top: 80px;
// `;

export const GalleryItem = styled.div`
  width: 100%;
  padding-top: 160px;
  overflow: hidden;
  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    animation: scroll 30s linear infinite;
    img {
      white-space: nowrap;
    }
  }
  &.row-2 {
    @keyframes secondscroll {
      0% {
        transform: translateX(-50%);
      }
      100% {
        transform: translateX(0);
      }
    }
    div {
      animation: secondscroll 25s linear infinite;
    }
  }
`;

export const GalleryItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  width: 100%;
  overflow: hidden;
  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;